import { useEffect, useMemo, useState } from 'react'
import { Button } from 'antd'
import { RfScannerIcon } from 'icons/Icons'
import { attachRFID, detachRFID, getRFIDReader, getRFIDReaders } from 'api/shippingV3.api'
import { updateAllowBarcodeScanState, updateRfidScannerConnected } from 'store/slices/shippingDocumentSliceV3'
import { notificationController } from 'controllers/notificationController'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useNavigate, useParams } from 'react-router-dom'
import WifiIcon from 'icons/svg/WifiIcon'
import RfidListIcon from 'icons/svg/RfidListIcon'
import './ScannerList.css'
import { capitalize } from 'lodash'
import { isDocDeliveredOrAppr } from 'utils/utils'
import useFetchRFIDReaders from 'hooks/useFetchRFIDReaders'
import RfidAttachModelShared from 'components/common/RfidAttachModelShared'
interface RfidItem {
  attached: string;
  label: string;
  key: number
}
const ScannersList = () => {
  const [rfidDropDown, setRfidDropDown] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedReader, setSelectedReader] = useState<RfidItem>();
  const [rfidAttachModelVisible, setRfidAttachModelVisible] = useState<any>(false);

  const navigate = useNavigate();
  const fetchRFIDReaders = useFetchRFIDReaders()
  const dispatch = useAppDispatch();
  const { id } = useParams();
  const { allow_barcode_Scanning, rfid_Scanner_connected } = useAppSelector((state) => state.shippingDocument);
  const { shipping_document_details, rfid_readers } = useAppSelector((state) => state.shippingDocumentV3);

  const isDeliveredOrAppr = useMemo(()=>{
    return isDocDeliveredOrAppr(shipping_document_details)
  }, [shipping_document_details])

  const handleBarcodeScanner = () => {
    navigate(`shipment-document-v3/details/${id}/barcode`);
    dispatch(updateAllowBarcodeScanState(!allow_barcode_Scanning))
    notificationController.success({
      message: `Barcode Scanner ${allow_barcode_Scanning ? 'Activated' : 'DeActivated'} Successfully`
    })
  }

  const handleRfidScanner = (rfid: RfidItem) => {
    if (rfid.attached == "1") {
      detachRFID({ rfid_reader_id: rfid.key }).then(
        () => {
          fetchRFIDReaders()
          setRfidDropDown(false)
          notificationController.success({
            message: 'RFID Scanner Disconnected Successfully',
          });
        },
        (err: any) => {
          setRfidDropDown(false)
          notificationController.error({ message: err.message });
        })
    } else {
      setRfidDropDown(false)
      setSelectedReader(rfid)
      setRfidAttachModelVisible(true)
    }
  }

  useEffect(() => {
    fetchRFIDReaders()
  }, []);

  return (
    <>
      {rfidDropDown && (
        <div
          onClick={() => setRfidDropDown(false)}
          className='overlay'
        />
      )}
      <div className="justify-center">
        <div className="icon-container">
          <Button onClick={handleBarcodeScanner} type="link" disabled={isDeliveredOrAppr}>
            <RfScannerIcon color={!allow_barcode_Scanning && !isDeliveredOrAppr ? '#268959' : '#BBBBBB'} />
          </Button>
        </div>
        <div className="px-4">
          <Button type="link"
            onClick={() => setRfidDropDown(!rfidDropDown)}
          >
            <RfidListIcon filled={rfid_Scanner_connected} />
          </Button>
          {rfidDropDown && (
            <div className="dropdown-overlay">
              {rfid_readers?.map((item: any) => {
                return (
                  <ul className="dropdown-list">
                    <li
                      onClick={() => handleRfidScanner(item)}
                      className={`dropdown-iem ${item.attached_to_me === "1" ? 'selected-item' : ''} ${item.attached === "1" ? 'selected-bold-item' : ''}`}
                      >
                      <WifiIcon filled={item.attached == "1" ? true : false} />
                      {capitalize(item.label)}
                    </li>
                  </ul>
                )
              })}
            </div>
          )}
        </div>
      </div>
      {rfidAttachModelVisible &&
        <RfidAttachModelShared
          isLoading={isLoading}
          defaultReader={selectedReader}
          setIsLoading={setIsLoading}
          rfidAttachModelVisible={rfidAttachModelVisible}
          setRFIDAttachRequired={setIsLoading}
          reloadScanners={fetchRFIDReaders}
          setRfidAttachModelVisible={setRfidAttachModelVisible}
          attachRFID={attachRFID}
          getRFIDReaders={getRFIDReaders}
          btnText={"Attach"}
        ></RfidAttachModelShared>
      }
    </>
  )
}

export default ScannersList